import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Event as RouterEvent, NavigationEnd, Params, Router } from '@angular/router';
import { keys } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AppRoutesParams } from '../constants/app.constants';

@Injectable()
export class RouteParamsService {
  private router = inject(Router);

  params: BehaviorSubject<Record<AppRoutesParams, string>>;
  paramsSnapshot: Record<AppRoutesParams, string>;

  params$: Observable<Params>;

  constructor() {
    this.paramsSnapshot = {} as Record<AppRoutesParams, string>;
    this.params = new BehaviorSubject(this.paramsSnapshot);
    this.params$ = this.params.asObservable();
  }

  init() {
    this.router.events.pipe(filter((event: RouterEvent) => event instanceof NavigationEnd)).subscribe((_) => {
      const snapshot = this.router.routerState.snapshot.root;
      const nextParams = this.collectParams(snapshot);

      if (this.paramsAreDifferent(this.paramsSnapshot, nextParams)) {
        this.params.next((this.paramsSnapshot = nextParams as Record<AppRoutesParams, string>));
      }
    });
  }

  private collectParams(root: ActivatedRouteSnapshot): Params {
    const params: Params = {};

    (function mergeParamsFromSnapshot(snapshot: ActivatedRouteSnapshot) {
      Object.assign(params, snapshot.params);
      snapshot.children.forEach(mergeParamsFromSnapshot);
    })(root);

    return params;
  }

  private paramsAreDifferent(currentParams: Params, nextParams: Params) {
    const currentKeys = keys(currentParams);
    const nextKeys = keys(nextParams);

    if (currentKeys.length !== nextKeys.length) return true;

    for (let i = 0, length = currentKeys.length; i < length; i++) {
      const key = currentKeys[i];
      if (currentParams[key] !== nextParams[key]) return true;
    }

    return false;
  }
}
